import { gql } from '@apollo/client';

export const UPSERT_COMMUNITY_GROUP_TOPIC = gql`
  mutation UpsertCommunityGroupTopic($communityGroupId: ID!, $topicName: String!, $input: UpsertTopicInput!) {
    upsertCommunityGroupTopic(communityGroupId: $communityGroupId, topicName: $topicName, input: $input) {
      name
      humanModerationAssignedTtlInSeconds
      maxCasesPerModerator
      humanModerationCasesSlaInSeconds
    }
  }
`;
